'use client';

import { sendGTMEvent } from '@next/third-parties/google';

import { RegisterStep } from '@/app/lcv/components/campaigns/big-campaign-2026/constants';
import { LEAD_FORM_PAYLOAD_KEYS } from '@/app/lib/forms/tracking/constants';
import { isDataLayerAvailable } from '@/tag-manager';
import { CUSTOM_EVENT_DYNAMIC_EVENT } from '@/tag-manager/constants';

export const BIG_CAMPAIGN_2026_EVENT = 'register-big-campaign-2026';

export const STEP_NAME = {
  [RegisterStep.form]: 'form',
  [RegisterStep.spin]: 'spin',
  [RegisterStep.summary]: 'summary',
};

export const trackBigCampaign2026 = ({
  value,
  step,
  text,
  groupName,
}: {
  step?: number;
  text?: string;
  value?: string;
  groupName?: string;
}) => {
  if (!isDataLayerAvailable()) return;

  const reset = Object.fromEntries(
    LEAD_FORM_PAYLOAD_KEYS.map((key) => [key, undefined])
  );
  const stepName = step ? STEP_NAME[step] : undefined;
  sendGTMEvent({
    ...reset,
    event: CUSTOM_EVENT_DYNAMIC_EVENT,
    event_name: BIG_CAMPAIGN_2026_EVENT,
    group: stepName,
    // Read by the GTM dynamic-event tag.
    group_name: groupName,
    step_name: stepName,
    text,
    value,
  });
};
